module.exports = __webpack_public_path__ + "img/loading.470fd1db.png";